module.exports = __webpack_public_path__ + "img/1366.bdf76e1e.png";